import { render, staticRenderFns } from "./coach-registration-print.vue?vue&type=template&id=4b9070c4&scoped=true&"
import script from "./coach-registration-print.vue?vue&type=script&lang=js&"
export * from "./coach-registration-print.vue?vue&type=script&lang=js&"
import style0 from "./coach-registration-print.vue?vue&type=style&index=0&id=4b9070c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9070c4",
  null
  
)

export default component.exports